import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ArticleService } from '../../../service/article.service';
import { Article } from '../../../models/Article';

@Component({
  selector: 'app-model-delete-article',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './model-delete-article.html',
  styleUrls: ['./model-delete-article.scss']
})
export class ModelDeleteArticle implements OnInit {
  private articleService = inject(ArticleService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  loading = signal(false);
  success = signal(false);
  error = signal<string | null>(null);

  codigo = 0;
  usuarioPk = 0;
  article: Article | null = null;

  ngOnInit(): void {
    this.codigo = Number(this.route.snapshot.paramMap.get('codigo'));

    const authUser = localStorage.getItem('authUser');
    if (authUser) {
      const user = JSON.parse(authUser);
      this.usuarioPk = Number(user.pkUsuario);
    }

    if (this.codigo) {
      this.articleService.getById(this.codigo).subscribe({
        next: (res) => {
          this.article = res;
        },
        error: () => {
          this.error.set('No se pudo cargar la información del artículo.');
        }
      });
    }
  }

  private buildArticleBitacora(a: Article): string {
    return [
      `Pk:${a.codigo ?? ''}`,
      `Fk_Seccion:${a.fkSeccion ?? ''}`,
      `Fk_Division:${a.fkDivision ?? ''}`,
      `Fk_Clase:${a.fkClase ?? ''}`,
      `Fk_Producto:${a.fkProducto ?? ''}`,
      `Fk_Variedad:${a.fkVariedad ?? ''}`,
      `Codigo_INE:${a.codigoIne ?? ''}`,
      `Nombre:${a.nombre ?? ''}`,
      `Unidad_Medida:${a.fkUnidadMedida ?? ''}`,
      `Factor_Conversion:${a.factorConversion ?? ''}`,
      `Calculo:${a.calculo ?? ''}`,
      `Calculo_Alterno:${a.calculoAlterno ?? ''}`,
      `Codigo_CIIU:${a.codigoCiiu ?? ''}`,
      `Codigo_NAEG:${a.codigoNaeg ?? ''}`,
      `Codigo_NPG:${a.codigoNpg ?? ''}`,
      `Codigo_CCP:${a.codigoCcp ?? ''}`,
      `Referencia:${a.referencia ?? ''}`,
      `Estado:${a.estado ?? ''}`
    ].join('|') + '|';
  }

  onConfirmDelete(): void {
    if (!this.codigo || !this.usuarioPk || !this.article) {
      this.error.set('No se pudo obtener el artículo o el usuario.');
      return;
    }

    this.loading.set(true);
    this.error.set(null);

    const articleAnterior: Article = {
      ...this.article,
      segDatosAnteriores: this.buildArticleBitacora(this.article)
    };

    this.articleService.delete(this.codigo, this.usuarioPk, articleAnterior).subscribe({
      next: () => {
        this.loading.set(false);
        this.success.set(true);
      },
      error: () => {
        this.loading.set(false);
        this.error.set('Error al eliminar el artículo.');
      }
    });
  }

  onCancel(): void {
    this.router.navigate(['/search-article']);
  }
}